// extracted by mini-css-extract-plugin
module.exports = {"optionbox":"ColumnChoice_optionbox__2Xug9"};